import { styled } from '../../../../../packages/theme/stitches.config';

export const CompetitionLogo = styled.withConfig({ componentId: 'MultisportWidget', displayName: 'CompetitionLogo' })('div', {
  height: '$3',
  width: '$3',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
});
